import { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Navigation, NavigationButton } from 'containers/Navigation';
import { GameContext } from 'contexts/GameContext';
import { UserContext } from 'contexts/UserContext';
import gameConstants from 'constants/game';
import { Span } from 'elements/Text';
import { getId } from 'store/filer';
import events from 'store/events';

const { areas } = gameConstants;

const Actions = () => {
  const dispatch = useDispatch();
  const user = useContext(UserContext)
  const game = useContext(GameContext);
  const isSaveDisabled = useMemo(() =>
    game && user?.saves[getId(game)],
    [game, user]
  );

  return game ? (
    <>
      <Navigation>
        <Span>Reset:</Span>
        <NavigationButton
          onClick={() => dispatch({ type: events.reset, area: areas.letter })}
        >
          Letter
        </NavigationButton>
        <NavigationButton
          onClick={() => dispatch({ type: events.reset, area: areas.board })}
        >
          Board
        </NavigationButton>
      </Navigation>
      <Navigation>
        <Span>Check:</Span>
        <NavigationButton
          onClick={() => dispatch({ type: events.check, area: areas.letter })}
        >
          Letter
        </NavigationButton>
        <NavigationButton
          onClick={() => dispatch({ type: events.check, area: areas.board })}
        >
          Board
        </NavigationButton>
      </Navigation>
      <Navigation>
        <Span>Solve:</Span>
        <NavigationButton
          onClick={() => dispatch({ type: events.solve, area: areas.letter })}
        >
          Letter
        </NavigationButton>
        <NavigationButton
          onClick={() => dispatch({ type: events.solve, area: areas.board})}
        >
          Board
        </NavigationButton>
      </Navigation>
      <Navigation>
        <NavigationButton
          onClick={() => console.log('undo!')}
          disabled
        >
          Undo
        </NavigationButton>
        <NavigationButton
          onClick={() => console.log('redo!')}
          disabled
        >
          Redo
        </NavigationButton>
      </Navigation>
      <Navigation>
        <NavigationButton
          onClick={() => dispatch({ type: events.handleSave })}
          disabled={isSaveDisabled}
        >
          Save{isSaveDisabled ? 'd': '*'}
        </NavigationButton>
      </Navigation>
    </>
  ) : null;
}

export default Actions;
